import React from "react";
import "./Services.scss";
import { Fade, Slide } from "react-awesome-reveal";
import serviceList from "../../utils/Services";
import { Link } from "react-router-dom";

function ServicesPage() {
  return (
    <div className="services-wrap">
      <div className="container">
        <div className="heading ">
          <Slide direction="up">
            <h3>Our Services</h3>
          </Slide>
          <Slide direction="up">
            <h5>As per your needs, imagination, emotions and location.</h5>
          </Slide>
        </div>
        <div className="content spacing">
          <div className="inner">
            <div className="services-wrap ">
              <div className="s-inner">
                {serviceList?.map((item) => {
                  return (
                    <div className="service-item" key={item.id}>
                      <div className="service-item-inner">
                        <Fade cascade damping={0.3}>
                          <Link to={item.link} className="si-img">
                            <img src={item.image} alt={item.name} />
                          </Link>
                          <div className="si-content">
                            <h6>
                              <Link className="animateLine" to={item.link}>
                                {item.name}
                              </Link>
                            </h6>
                            <p>{item.desc}</p>

                            <Link
                              to={`mailto:wowwishMoments@gmail.com?subject=Inquiry For ${item.name}`}
                              className="btn"
                            >
                              Enquiry Now
                            </Link>
                          </div>
                        </Fade>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServicesPage;
